import { take, put, race } from 'redux-saga/effects';
import { Actions as ShellActions, showConfirmation, hideConfirmation } from 'actions/shellActions';

export function* confirmSaga(confirmationMessage: string): Generator<any, boolean, any> {
    yield put(showConfirmation(confirmationMessage));

    const { yes } = yield race({
        yes: take(ShellActions.CONFIRM_YES),
        no: take(ShellActions.CONFIRM_NO),
        escape: take(ShellActions.ESCAPE),
    });

    yield put(hideConfirmation());

    return !!yes;
}
